import createReducer from "../createReducer";
import { color, commonFieldInput, commonFieldInputStyles } from "../fields/initails";
import { ColorPickerModes } from "./../../libs/Picker/types.d";
import { AlignmentTypes, WidthMeasurement } from "./../fields/boomtypes";
import { authHandlers } from "./handlers";
import { IFormsState } from "./types";

export const FormState: IFormsState = {
    current: null,
    isTransfering: false,
    isLoading: false,
    ownerId: "",
    settings: {
        native: {
            currency: "USD",
            priceFormat: "100$",
        },
    },
    error: null,
    fonts: [
        {
            family: "Montserrat",
            variants: ["300", "regular", "500", "600", "700"],
            subsets: ["cyrillic", "cyrillic-ext", "latin", "latin-ext", "vietnamese"],
            version: "v25",
            files: {
                "300": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pGImV6jasN9-8w.ttf",
                regular:
                    "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pHjnV6jasN9-8w.ttf",
                "500": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pF1mV6jasN9-8w.ttf",
                "600": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pD-mF6jasN9-8w.ttf",
                "700": "http://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpSv69pCzml6jasN9-8w.ttf",
            },
            category: "sans-serif",
            kind: "webfonts#webfont",
        },
        {
            family: "Quicksand",
            variants: ["300", "regular", "500", "600", "700"],
            subsets: ["latin", "latin-ext", "vietnamese"],
            version: "v30",
            files: {
                "300": "http://fonts.gstatic.com/s/Montserrat/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkKEo18G0wx40QDw.ttf",
                "500": "http://fonts.gstatic.com/s/Montserrat/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkM0o18G0wx40QDw.ttf",
                "600": "http://fonts.gstatic.com/s/Montserrat/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkCEv18G0wx40QDw.ttf",
                "700": "http://fonts.gstatic.com/s/Montserrat/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkBgv18G0wx40QDw.ttf",
                regular:
                    "http://fonts.gstatic.com/s/Montserrat/v30/6xK-dSZaM9iE8KbpRA_LJ3z8mH9BOJvgkP8o18G0wx40QDw.ttf",
            },
            category: "sans-serif",
            kind: "webfonts#webfont",
        },
        {
            family: "ABeeZee",
            variants: ["regular", "italic"],
            subsets: ["latin", "latin-ext"],
            version: "v22",
            files: {
                regular: "http://fonts.gstatic.com/s/abeezee/v22/esDR31xSG-6AGleN6tKukbcHCpE.ttf",
                italic: "http://fonts.gstatic.com/s/abeezee/v22/esDT31xSG-6AGleN2tCklZUCGpG-GQ.ttf",
            },
            category: "sans-serif",
            kind: "webfonts#webfont",
        },
        {
            family: "Abhaya Libre",
            variants: ["regular", "500", "600", "700", "800"],
            subsets: ["latin", "latin-ext", "sinhala"],
            version: "v13",
            files: {
                "500": "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYj2ryqtxI6oYtBA.ttf",
                "600": "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYo23yqtxI6oYtBA.ttf",
                "700": "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEYx2zyqtxI6oYtBA.ttf",
                "800": "http://fonts.gstatic.com/s/abhayalibre/v13/e3t5euGtX-Co5MNzeAOqinEY22_yqtxI6oYtBA.ttf",
                regular: "http://fonts.gstatic.com/s/abhayalibre/v13/e3tmeuGtX-Co5MNzeAOqinEge0PWovdU4w.ttf",
            },
            category: "serif",
            kind: "webfonts#webfont",
        },
        {
            family: "Bungee",
            variants: ["regular"],
            subsets: ["latin", "latin-ext", "vietnamese"],
            version: "v11",
            files: {
                regular: "http://fonts.gstatic.com/s/bungee/v11/N0bU2SZBIuF2PU_ECn50Kd_PmA.ttf",
            },
            category: "display",
            kind: "webfonts#webfont",
        },
        {
            family: "Abel",
            variants: ["regular"],
            subsets: ["latin"],
            version: "v18",
            files: {
                regular: "http://fonts.gstatic.com/s/abel/v18/MwQ5bhbm2POE6VhLPJp6qGI.ttf",
            },
            category: "sans-serif",
            kind: "webfonts#webfont",
        },
    ],
    styles: {
        background: {
            color: {
                type: ColorPickerModes.SOLID,
                style: "#f8f8f8",
                value: { alpha: 1, blue: 248, green: 248, hue: 0, red: 248, saturation: 0, value: 97 },
            },
        },
        page: {
            widthMeasurement: WidthMeasurement.PERCENT,
            alignment: "left",
            border: {
                radius: 16,
                size: 0,
                color: color({
                    style: "#434e5a33",
                    type: 0,
                    value: {
                        alpha: 0.2,
                        blue: 90,
                        green: 78,
                        hue: 211,
                        red: 67,
                        saturation: 26,
                        value: 35,
                    },
                }),
            },
            fill: {
                color: color({
                    style: "#fff",
                    type: 0,
                    value: {
                        alpha: 1,
                        blue: 255,
                        green: 255,
                        hue: 0,
                        red: 255,
                        saturation: 0,
                        value: 100,
                    },
                }),
            },
        },
        buttons: {
            submit: {
                input: commonFieldInput(
                    "Submit",
                    {
                        widthMeasurement: WidthMeasurement.PX,
                        widthPx: 80,
                        border: {
                            borderSize: "0",
                        },
                        inputValueWeight: 500,
                        inputValueAlignment: AlignmentTypes.CENTER,
                        inputValueColor: color({
                            style: "#FFFFFF",
                            type: 0,
                            value: {
                                alpha: 1,
                                blue: 90,
                                green: 78,
                                hue: 211,
                                red: 67,
                                saturation: 26,
                                value: 35,
                            },
                        }),
                        inputFillColor: color({
                            style: "#33bfa1",
                            type: 0,
                            value: {
                                alpha: 0.2,
                                blue: 90,
                                green: 78,
                                hue: 211,
                                red: 67,
                                saturation: 26,
                                value: 35,
                            },
                        }),
                    },
                    "Submit",
                ),
            },
            back: {
                input: commonFieldInput(
                    "Back",
                    {
                        widthMeasurement: WidthMeasurement.PX,
                        widthPx: 88,
                        border: {
                            borderSize: 1,
                            inputBorderColor: color({
                                style: "#33bfa1",
                                type: 0,
                                value: {
                                    alpha: 0.2,
                                    blue: 90,
                                    green: 78,
                                    hue: 211,
                                    red: 67,
                                    saturation: 26,
                                    value: 35,
                                },
                            }),
                        },
                        inputValueWeight: 500,
                        inputValueAlignment: AlignmentTypes.CENTER,
                        inputValueColor: color({
                            style: "#33bfa1",
                            type: 0,
                            value: {
                                alpha: 0.2,
                                blue: 90,
                                green: 78,
                                hue: 211,
                                red: 67,
                                saturation: 26,
                                value: 35,
                            },
                        }),
                    },
                    "Back",
                ),
                icon: {
                    styles: {
                        input: {
                            ...commonFieldInputStyles({
                                inputValueSize: "24",
                                inputFillColor: color({
                                    style: "#434E5A",
                                    type: 0,
                                    value: {
                                        alpha: 1,
                                        blue: 255,
                                        green: 255,
                                        hue: 0,
                                        red: 255,
                                        saturation: 0,
                                        value: 100,
                                    },
                                }),
                                border: {
                                    borderSize: "0",
                                },
                                borderColorStyle: "#33bfa1",
                                borderRadius: 50,
                            }).input,
                            hoverColor: commonFieldInputStyles({
                                inputValueSize: "24",
                                inputFillColor: color({
                                    style: "#434E5A",
                                    type: 0,
                                    value: {
                                        alpha: 1,
                                        blue: 255,
                                        green: 255,
                                        hue: 0,
                                        red: 255,
                                        saturation: 0,
                                        value: 100,
                                    },
                                }),
                                border: {
                                    borderSize: "0",
                                },
                                borderColorStyle: "#33bfa1",
                                borderRadius: 50,
                            }).input.border.color,
                        },
                        inputValue: commonFieldInputStyles({
                            inputValueSize: "24",
                            inputFillColor: color({
                                style: "#434E5A",
                                type: 0,
                                value: {
                                    alpha: 1,
                                    blue: 255,
                                    green: 255,
                                    hue: 0,
                                    red: 255,
                                    saturation: 0,
                                    value: 100,
                                },
                            }),
                            border: {
                                borderSize: "0",
                            },
                            borderColorStyle: "#33bfa1",
                            borderRadius: 50,
                        }).inputValue,
                    },
                    // commonFieldInputStyles({
                    //     inputValueSize: "24",
                    //     inputFillColor: color({
                    //         style: "#434E5A",
                    //         type: 0,
                    //         value: {
                    //             alpha: 1,
                    //             blue: 255,
                    //             green: 255,
                    //             hue: 0,
                    //             red: 255,
                    //             saturation: 0,
                    //             value: 100,
                    //         },
                    //     }),
                    //     border: {
                    //         borderSize: "0",
                    //     },
                    //     borderColorStyle: "#33bfa1",
                    //     borderRadius: 50,
                    // }),
                },
            },
            next: {
                input: commonFieldInput(
                    "Next",
                    {
                        widthMeasurement: WidthMeasurement.PX,
                        widthPx: 100,
                        border: {
                            borderSize: "0",
                        },
                        inputValueWeight: 500,
                        inputValueAlignment: AlignmentTypes.CENTER,
                        inputValueColor: color({
                            style: "#FFFFFF",
                            type: 0,
                            value: {
                                alpha: 1,
                                blue: 90,
                                green: 78,
                                hue: 211,
                                red: 67,
                                saturation: 26,
                                value: 35,
                            },
                        }),
                        inputFillColor: color({
                            style: "#33bfa1",
                            type: 0,
                            value: {
                                alpha: 0.2,
                                blue: 90,
                                green: 78,
                                hue: 211,
                                red: 67,
                                saturation: 26,
                                value: 35,
                            },
                        }),
                    },
                    "Next",
                ),
                icon: {
                    styles: {
                        input: {
                            ...commonFieldInputStyles({
                                inputValueSize: "24",
                                inputFillColor: color({
                                    style: "#434E5A",
                                    type: 0,
                                    value: {
                                        alpha: 1,
                                        blue: 255,
                                        green: 255,
                                        hue: 0,
                                        red: 255,
                                        saturation: 0,
                                        value: 100,
                                    },
                                }),
                                border: {
                                    borderSize: "0",
                                },
                                borderColorStyle: "#33bfa1",
                                borderRadius: 50,
                            }).input,
                            hoverColor: commonFieldInputStyles({
                                inputValueSize: "24",
                                inputFillColor: color({
                                    style: "#434E5A",
                                    type: 0,
                                    value: {
                                        alpha: 1,
                                        blue: 255,
                                        green: 255,
                                        hue: 0,
                                        red: 255,
                                        saturation: 0,
                                        value: 100,
                                    },
                                }),
                                border: {
                                    borderSize: "0",
                                },
                                borderColorStyle: "#33bfa1",
                                borderRadius: 50,
                            }).input.border.color,
                        },
                        inputValue: commonFieldInputStyles({
                            inputValueSize: "24",
                            inputFillColor: color({
                                style: "#434E5A",
                                type: 0,
                                value: {
                                    alpha: 1,
                                    blue: 255,
                                    green: 255,
                                    hue: 0,
                                    red: 255,
                                    saturation: 0,
                                    value: 100,
                                },
                            }),
                            border: {
                                borderSize: "0",
                            },
                            borderColorStyle: "#33bfa1",
                            borderRadius: 50,
                        }).inputValue,
                    },
                },
            },
        },
    },
};
export default createReducer(FormState, authHandlers);
